import * as Actions from 'store/actions/app/_operators.actions'

const initialState = {
  operators: null,
  set_crud_operator: null,
}

const operatorsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ALL_OPERATORS: {
      return {
        ...state,
        operators: action.payload,
      }
    }
    case Actions.CRUD_OPERATOR: {
      return {
        ...state,
        set_crud_operator: action.payload,
      }
    }
    default: {
      return state
    }
  }
}
export default operatorsReducer
